import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "el-dropdown-link table-handle-more" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.btnList.length < 3)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.btnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_link, {
            key: index,
            class: "mr-10",
            href: item.href ? item.href(_ctx.scopeRow) : 'javascript:void(0)',
            target: item.target,
            type: item.type || 'primary',
            onClick: ($event: any) => (_ctx.handleCommand(item.command, _ctx.scopeRow))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["href", "target", "type", "onClick"]))
        }), 128))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.btnList, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (index < 1)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  class: "mr-10",
                  href: item.href ? item.href(_ctx.scopeRow) : 'javascript:void(0)',
                  target: item.target,
                  type: item.type || 'primary',
                  onClick: ($event: any) => (_ctx.handleCommand(item.command, _ctx.scopeRow)),
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["href", "target", "type", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256)),
    (_ctx.btnList.length > 2 && _ctx.showMoreAction)
      ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 2 }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btnList, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (index >= 1 )
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: index }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              class: "mr-10",
                              href: item.href ? item.href(_ctx.scopeRow) : 'javascript:void(0)',
                              target: item.target,
                              type: item.type || 'primary',
                              onClick: ($event: any) => (_ctx.handleCommand(item.command, _ctx.scopeRow))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["href", "target", "type", "onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _cache[0] || (_cache[0] = _createTextVNode(" 更多 ", -1)),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_arrow_down)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}